import script from "./chart6.vue?vue&type=script&lang=ts&setup=true"
export * from "./chart6.vue?vue&type=script&lang=ts&setup=true"

import "./chart6.vue?vue&type=style&index=0&id=1680308d&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1680308d"]])

export default __exports__